import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const StyledButton = styled('button')({
  '&&': {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    color: '#1976d2', // MUI primary blue color
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '1rem',
    fontFamily: 'Roboto, sans-serif',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    '&:hover': {
      color: '#115293',
      textDecoration: 'underline'
    },

    '&:focus': {
      outline: 'none'
    }
  }
});

const UnderlineButton = ({
  text,
  onClick,
  icon,
  className
}) => (
  <StyledButton
    className={className}
    onClick={onClick}
    type="button"
  >
    {text}
    {icon && icon}
  </StyledButton>
);

UnderlineButton.defaultProps = {
  icon: null,
  className: ''
};

UnderlineButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.elementType,
  className: PropTypes.string
};

export default UnderlineButton;
